import { AgencyQueryProvider } from "__legacy/queries/agencies/AgencyQueryProvider";
import { CreateEmploymentMutationProvider } from "__legacy/queries/employments/CreateEmploymentMutationProvider";
import { Button, Form, Layout, PageHeader } from "antd";
import { Fragment, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { onError, onFinish, UserForm } from "./UserForm";

export const New: React.FC<{}> = () => {
  const { agencyId } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<string[]>([]);

  return (
    <AgencyQueryProvider variables={{ id: agencyId }}>
      {({ agency }) => (
        <CreateEmploymentMutationProvider onError={onError(form, setErrors)} onCompleted={() => navigate("../../")}>
          {(loading, mutate) => (
            <Fragment>
              <PageHeader
                ghost={true}
                title={`New agency user for ${agency.name}`}
                extra={
                  <Fragment>
                    <Button onClick={() => navigate("../../../")}>Back to list</Button>
                    <Button onClick={() => navigate("../../")}>Back to agency</Button>
                    <Button type="primary" loading={loading} onClick={() => form.submit()}>
                      Save
                    </Button>
                  </Fragment>
                }
              />
              <Layout.Content className="content">
                <UserForm
                  action="create"
                  form={form}
                  handler={onFinish(mutate, { agencyId }, {})}
                  values={{}}
                  errors={errors}
                />
              </Layout.Content>
            </Fragment>
          )}
        </CreateEmploymentMutationProvider>
      )}
    </AgencyQueryProvider>
  );
};
